import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { EntitySelect } from '@/common/form/formFields/EntitySelect';
import { ValList } from '@/common/val/ValList';
import { McoDispList } from '../mcoDisp/McoDispList';

export const McoInvLineDetail = () => {
  const { entityObj } = useEntityMgr();

  const augMcoInvFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.code.component = <EntitySelect key="code" fieldDef={fieldToFieldDef.code} />;
  };

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    {
      id: 'mcoInv',
      label: 'Invoice',
      content: <EntityForm entity="MCO_INV" entityId={entityObj.mcoInvId} augFieldDefs={augMcoInvFieldDefs} />,
    },
    {
      id: 'disps',
      label: 'Disputes',
      content: <McoDispList mcoInvLineId={entityObj.id} partition={entityObj.invPeriodCode} />,
    },
    {
      id: 'valTab',
      label: 'Validations',
      content: <ValList parentEntity="MCO_INV_LINE" parentEntityId={entityObj.id} />,
    },
  ];

  return <EntityDetail tabSpecs={tabSpecs} />;
};
